module.exports = [
  "igga",
  "ibba",
  "iggr",
  "aggot",
  "1gger",
  "fag",
  "kike",
  "卐",
  "nignog",
  "nignug",
  "bigga",
  "libtard",
  "retard",
  "k1ke",
  "kik3",
  "k1k3",
  "tard",
  "t4rd",
  "fag",
  "f4gg0t",
  "f4ggot",
  "fagg0t",
  "niglet",
  "etard",
  "nigg",
  "nigger",
  "negro",
  "KKK",
  "rape",
  "niger",
];
